import {defineStore} from "pinia";
import axios from "axios";

const API_BASE_URL = 'https://jeu.programme-climeco.fr';

export const useNetworkStore = defineStore('network', {
  state: () => ({
    uuid: null,
  }),
  actions: {
    async post({url, data}) {
      try {
        return await axios.post(`${API_BASE_URL}${url}`, data,
          {
            headers: {'Content-Type': 'application/json'}
          })
          .then(response => response.data);
      } catch (e) {
        console.log('Unable to post data', e.message);
        throw e;
      }
    },

    async sendStartGame(data) {
      const response = await this.post({url: '/api/game_session/', data});
      this.uuid = response.uuid;
      return response;
    },

    async sendAnswer(data) {
      data.session = this.uuid;
      return await this.post({url: '/api/answer/', data});
    }
  }
});